import React from 'react';
import {SwitchTransition, Transition} from "react-transition-group";
import {cableTrayOptions, floorTypes, roomTypes} from "../../config/options";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faImage} from "@fortawesome/free-solid-svg-icons";
import {Room} from '../../config/interfaces';
import {Start, Rooms} from "../../views";
import HouseType from "../../views/HouseType";
import {HouseType as HouseTypeEnum, WallType as WallTypeEnum} from '../../config/enums';
import ConstructionYear from "../../views/ConstructionYear";
import WallType from "../../views/WallType";

interface ViewerProps {
    currentItem: string;
    roomsRef: React.MutableRefObject<HTMLDivElement[]>;
    addRoom: () => void;
    removeRoom: (i: number) => void;
    roomsSurfaces: number[];
    rooms: Room[];
    houseType: HouseTypeEnum;
    constructionYear: number;
    wallType: WallTypeEnum;
}

/**
 * Component with Viewer with detailed information for the currently scrolled element
 * @param {ViewerProps} props - The props that the Viewer component accepts.
 * @param {string} props.currentItem - The current item to display
 * @param {React.MutableRefObject<HTMLDivElement[]>} props.roomsRef - Array of references to the rooms InputItems that can be scrolled
 * @param {Function} props.addRoom - Function to add a room
 * @param {Function} props.removeRoom - Function to remove a room
 * @param {number[]} props.roomsSurfaces - List of the room surfaces (with real-time changes, the ones in rooms are only updates after letting the sliders go)
 * @param {Room[]} props.rooms - Array of rooms
 * @param {HouseTypeEnum} props.houseType - Type of housing
 * @param {number} props.constructionYear - Year of construction
 * @param {WallTypeEnum} props.wallType - Type of wall
 * @constructor
 */
export default function Viewer(props: ViewerProps) {
    const {currentItem, roomsRef, addRoom, removeRoom, roomsSurfaces, rooms, houseType, constructionYear, wallType} = props;
    const getViewerView = () => {
        switch (currentItem.split(':')[0]) {
            case 'airco-designer':
                return <Start />;
            case 'house-type':
                return <HouseType houseType={houseType} />;
            case 'construction-year':
                return <ConstructionYear constructionYear={constructionYear} />;
            case 'wall-type':
                return <WallType wallType={wallType} />;
            case 'room':
                return <Rooms rooms={rooms} roomsRef={roomsRef} roomTypes={roomTypes} cableTrayOptions={cableTrayOptions} addRoom={addRoom} removeRoom={removeRoom} floorTypes={floorTypes} currentItem={currentItem} roomsSurfaces={roomsSurfaces} />;
            default:
                return <div id={'viewer'} className={'no-view'}>
                    <FontAwesomeIcon icon={faImage} />
                    <span style={{fontSize: 30}}>{currentItem}</span>
                </div>;
        }
    }

    return <SwitchTransition mode={'out-in'}>
        <Transition key={currentItem.split(':')[0]} timeout={100} classNames={'slide'} mountOnEnter unmountOnExit>
            {state => {
                return <div className={'slide'} style={{transition: 'opacity 0.4s', opacity: state === 'entered' ? 1 : 0, display: state === 'exited' ? 'none' : 'flex'}}>
                    {getViewerView()}
                </div>;
            }}
        </Transition>
    </SwitchTransition>
}